import type { WasteStreamWithUse } from "../types";
import { StreamEmblem } from "./streamEmblem";

type Props = {
  stream: WasteStreamWithUse;
};

export const StreamBadge: React.FC<Props> = ({ stream }) => {
  const isActive = stream.status === "active";
  const isRecommended = stream.status === "recommended";

  const skin = isActive
    ? {
        background: "#F3F5AE",
        border: "1px solid #DDE05A",
        color: "#1D1C1C",
        boxShadow: "0 1px 2px rgba(93,93,18,0.10)",
      }
    : isRecommended
      ? { background: "#fff", border: "1px dashed #D2D0AE", color: "#6F6C6C" }
      : {
          background: "#F4F0F0",
          border: "1px solid #E4DDDD",
          color: "#9a958f",
        };

  return (
    <span
      className="inline-flex cursor-default items-center gap-[9px] rounded-full py-[6px] pr-[16px] pl-[6px] text-[13px]"
      style={{
        background: skin.background,
        border: skin.border,
        color: skin.color,
        boxShadow: skin.boxShadow,
        fontWeight: isActive ? 600 : 500,
      }}
    >
      <StreamEmblem stream={stream} />
      {stream.name}
    </span>
  );
};
